import {
    ContentChild, Directive,
    ElementRef,
    EventEmitter,
    HostBinding,
    HostListener,
    Input,
    Output,
    ViewChild
} from "@angular/core";
import {FUIButtonComponent} from "../../buttons/button/button.component";
import {FUIIconComponent} from "../../icons/icon/icon.component";
import {ControlValueAccessor, FormControl} from "@angular/forms";

@Directive()
export class FUIAbstractPill implements ControlValueAccessor {
    @ContentChild(FUIButtonComponent) public button: FUIButtonComponent;
    @Input() public control: FormControl;
    private _disabled: boolean;
    @HostBinding("class.focussed") public focussed: boolean;
    @HostBinding("class.hovered") public hovered: boolean;
    @Output() public focussed$: EventEmitter<boolean>;
    @ContentChild(FUIIconComponent) public icon: FUIIconComponent;
    @ViewChild("input", {read: ElementRef}) public input: ElementRef;
    @Input() public label: string;
    @Input() public loading: boolean;
    @Input() public placeholder: string;
    @HostBinding("class.removed") public removed: boolean;
    @Output() public removed$: EventEmitter<boolean>;
    public tabindex: number;
    protected _value: any;
    @Output() public value$: EventEmitter<any>;
    @HostBinding("class.valued") public valued: boolean;
    @Output() public valueChange: EventEmitter<any>;

    constructor() {
        this.control = new FormControl();
        this.focussed$ = new EventEmitter<boolean>();
        this.removed$ = new EventEmitter<boolean>();
        this.value$ = new EventEmitter<any>();
        this.valueChange = new EventEmitter<any>();
    }

    /**
     *
     * @returns {boolean}
     */
    get disabled(): boolean {
        return this._disabled;
    }

    /**
     *
     * @param {boolean} disabled
     */
    @HostBinding("class.disabled")
    @Input()
    set disabled(disabled: boolean) {
        this._disabled = disabled;
        if (this._disabled) {
            this.tabindex = -1;
        }
        else {
            this.tabindex = 0;
        }
    }

    /**
     *
     * @returns {string}
     */
    get value(): any {
        return this._value;
    }

    /**
     *
     * @param value
     */
    @HostBinding("class.value")
    @Input()
    set value(value: any) {
        if (value !== this._value) {
            this._value = value;
            this.onChange(value);
            this.value$.emit(value);
        }
    }

    /**
     *
     */
    click(): void {
        this.focus();
    }

    /**
     * Set focus to an element
     * @param element
     */
    focus(): void {
        if (this.focussed) {

        }
        else {
            this.input.nativeElement.focus();

            this.focussed = true;
            this.focussed$.emit(this.focussed);
        }
    }

    /**
     * When focus is removed from the input
     * @param event
     */
    onBlur(event?: any): void {
        this.focussed = false;
        this.focussed$.emit(this.focussed);
    }

    /**
     * When focus is detected on the input
     * @param event
     */
    onFocus(event?: any): void {
        this.focus();
    }

    /**
     *
     * @param _
     */
    onChange = (_: any) => {

    };

    /**
     *
     */
    onTouched = () => {

    };

    @HostListener("mouseenter")
    mouseenter(): void {
        this.hovered = true;
    }

    @HostListener("mouseleave")
    mouseleave(): void {
        this.hovered = false;
    }

    /**
     * Emit remove event
     * @param event
     */
    remove(): void {
        this.removed = true;
        this.removed$.emit(this.removed);
    }

    /**
     *
     * @param value
     */
    writeValue(value: any): void {
        this._value = value;
    }

    /**
     *
     * @param fn
     */
    registerOnChange(fn: (_: any) => void): void {
        this.onChange = fn;
    }

    /**
     *
     * @param fn
     */
    registerOnTouched(fn: () => void): void {
        this.onTouched = fn;
    }
}
